// import React from 'react';
import { Link,useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import React, { useEffect, useState , useRef} from "react";
import '../styles/AboutPage.css';
import founderImg from "../assets/rajiamge.jpeg";
const AboutPage = () => {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const sliderRef = useRef(null);
const [isVisible, setIsVisible] = useState(false);
  const testimonials = [
  {
    text: `"We’d worked with two consultants before FNBDATALAB... systems we’d never had in four years of operating."`,
    name: "R.S.",
    role: "Founder · Deveras Restaurant · Bengaluru",
    highlight: null,
  },
  {
    highlight: "₹2.6L",
    title: "Pour-loss recovered monthly — The Scene Kitchen & Bar",
    desc1: "Beverage cost dropped from 38% to 28.8% in 6 weeks.",
    desc2: "Owner's first full weekend off in 2 years — Week 9.",
  },
  {
    text: `"I was losing ₹2.6L a month behind the bar... completely broken mental model of my own business."`,
    name: "D.M.",
    role: "Co-founder · The Scene Kitchen & Bar · Indiranagar",
  },
];

const TestimonialSlider = () => {
  const [index, setIndex] = useState(0);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setIndex((prev) => (prev + 1) % testimonials.length);
  //   }, 4000);
  

  //   return () => clearInterval(interval);
  // }, [testimonials.length]);
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setIndex((prev) => (prev + 1) % testimonials.length);
  //   }, 4000);

  //   return () => clearInterval(interval);
  // }, []);
  useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      setIsVisible(entry.isIntersecting);
    },
    { threshold: 0.4 } // 40% visible triggers animation
  );

  if (sliderRef.current) {
    observer.observe(sliderRef.current);
  }

  return () => {
    if (sliderRef.current) observer.unobserve(sliderRef.current);
  };
}, []);

}
  return (
    <div>
      <Navbar />
      
     


      <section className="about-hero layer layer-light">
  <div className="about-hero-container">

    {/* 🔥 NEW FLEX WRAPPER */}
    <div className="about-hero-content">

      {/* LEFT IMAGE */}
      {/* <div className="founder-image">
        <img src={founderImg} alt="Founder" />
      </div> */}

      {/* RIGHT CONTENT */}
      <div className="about-hero-text">
        <h4 className='philosophy-tag'>
          Built by Operators. Designed for Real-World Execution.
        </h4>

        <h1><b>FNBDATALAB was built from experience — not theory.</b></h1>

        <div className='client-type'>
          <p className="about-subhighlight">
            "I understand restaurant operations deeply — 
            not from the outside, but from inside the kitchen, the accounts, and the team 
            briefings. And after everything I've seen, I hold one belief above all others: systems 
            thinking is the key to scaling any hospitality business.
             Not harder work. Not better food. Not more marketing. Systems."
          </p>
          <p className="founder-signature">
            <b>— Founder, FNBDATALAB</b>
          </p>
        </div>

        <p className="about-subtitle">
          After two decades working in kitchens, boardrooms, and operations floors —
             I built FNBDATALAB for one reason: to give F&B founders the operating foundation their businesses deserve.
        </p>

        <p className="about-subtitle">
           We've lived the chaos. The month-ends that don't balance. The margins quietly eroding.
             The team that only functions when you're in the room. We built this to change that.
        </p>
      </div>
        <div className="founder-image">
        <img src={founderImg} alt="Founder" />
      </div>
    </div>
  </div>
</section>
      

      {/* <section className="about-section layer layer-light">
        <div className="about-container">
          <h2 className="section-title">Our Philosophy</h2>
          <p className="about-subtitle">These aren't just values on a wall. These are principles that guide every decision we make and every system we build.</p>
          <div className="philosophy-grid">
            <div className="philosophy-item"><span className="highlight"><b>Data should simplify decisions, not complicate them</b></span>
              <p>You don't need a data science degree. You need clear dashboards that show you what's working and what's not.
                 Information should clarify, not confuse.</p>
            </div>
            <div className="philosophy-item"><span className="highlight"><b>Systems create freedom, not rigidity</b></span>
              <p>When your business runs on documented processes instead of heroic effort, you get your life back. 
                Structure doesn't limit creativity—it protects it.</p>
            </div>
            <div className="philosophy-item"><span className="highlight"><b>Profitability is a discipline, not luck</b></span>
              <p>Great food gets people through the door. Strong operations keep them coming back and keep you profitable. 
                Consistency beats inspiration every time.</p>
            </div>
            <div className="philosophy-item"><span className="highlight"><b>Sustainable growth is built, not chased</b></span>
              <p>Control comes first. Growth follows. 
                We stabilize operations before activating visibility, ensuring your business strengthens with scale.</p>
            </div>
            <div className="philosophy-item"><span className="highlight"><b>Execution beats ideas</b></span>
              <p>We care less about what sounds good in theory and more about what actually works on your floor, in your kitchen, in your reality. 
                Theory doesn't survive Friday night.</p>
            </div>
          </div>
        </div>
      </section> */}


      <section className="about-section-alt layer layer-light">
        <div className="about-container">
          {/* <h4>Our Category</h4>
          <h2 className="section-title"><b>End-to-End Operating Intelligence for F&B</b></h2> */}
          
          <div className="approach-content">
            {/* <p className="about-subtitle">
             FNBDATALAB operates in a focused category: Operating Intelligence for Food & Beverage businesses.
            </p> */}
            {/* <p>
              FNBDATALAB is not a traditional consulting firm. We operate as a <span className="highlight"><b>single-window partner</b></span> for 
              F&B businesses, taking full ownership of outcomes — not just recommendations.
            </p> */}

            {/* <p>
              Our team combines hands-on experience in building and running full-service restaurants with deep expertise in 
              <b>  Technology, POS Systems, Performance Analytics, and Operational Design.</b>
            </p> */}

            <p className="client-type">
              {/* <strong>Every engagement begins with understanding how your business actually operates — and ends with systems that allow it to grow with confidence..</strong> */}
              <ul>
                <li className='rrr'>Not consulting.</li>
                <li className='rrr'>Not audits.</li>
                <li className='rrr'>Not slide decks.</li>
              </ul>
            </p>
            <p className="about-subtitle">We design, implement, and stabilise the operating systems restaurants actually run on —
               cost structures, workflows, execution discipline, and decision-ready data.</p>
            {/* <h2 className="section-title">How We Actually Work With You</h2>
            <p >This is the heart of what we do.
               Every capability exists to create control, protect margins, and build systems your team can rely on.
            </p>

            <div className="approach-grid">
              <button
                className="approach-item service-button"
                onClick={() =>
                  navigate("/services", { state: { scrollTo: "cost-optimisation" } })
                }
                title="Click here"
              >
              Operations & cost optimisation
              </button>
              {/* <div className="approach-item clickable"
              onClick={() => navigate("/services", { state: { scrollTo: "cost-optimisation" } })}>
                Operations & cost optimisation
            </div> */}
              {/* <div className="approach-item">Kitchen planning & execution systems</div> */}
              {/* <div className="approach-item clickable"
              onClick={() => navigate("/services", { state: { scrollTo: "kitchen-menu-systems" } })}>
                Kitchen planning & execution systems
            </div> */}


            {/* <button
              className="approach-item service-button"
              onClick={() =>
                navigate("/services", { state: { scrollTo: "kitchen-menu-systems" } })
              }
              title="Click here"
            >
              Kitchen planning & execution systems
            </button>
            <button
              className="approach-item service-button"
              onClick={() =>
                navigate("/services", { state: { scrollTo: "hiring-training" } })
              }
              title="Click here"
            >
             Menu engineering & R&D
            </button>
            <button
              className="approach-item service-button"
              onClick={() =>
                navigate("/services", { state: { scrollTo: "hiring-training" } })
              }
              title="Click here"
            >
             Staffing, hiring & training frameworks
            </button>
              <button
              className="approach-item service-button"
              onClick={() =>
                navigate("/services", { state: { scrollTo: "licensing-compliance" } })
              }
              title="Click here"
            >
             Licensing & regulatory compliance
            </button>
            <button
              className="approach-item service-button"
              onClick={() =>
                navigate("/services", { state: { scrollTo: "supply-chain" } })
              }
              title="Click here"
            >
             Supply chain & vendor management
            </button>
            <button
              className="approach-item service-button"
              onClick={() =>
                navigate("/services", { state: { scrollTo: "digital-growth" } })
              }
              title="Click here"
            >
             Digital marketing & brand positioning
            </button>
            <button
              className="approach-item service-button"
              onClick={() =>
                navigate("/services", { state: { scrollTo: "technology-pos" } })
              }
              title="Click here"
            >
             Technology & POS integration
            </button> */}

 

              {/* <div className="approach-item clickable"
              onClick={() => navigate("/services", { state: { scrollTo: "hiring-training"}})}
              >Menu engineering & R&D</div>
              <div className="approach-item clickable"
              onClick={() => navigate("/services", { state: { scrollTo: "hiring-training"}})}>
                Staffing, hiring & training frameworks</div>
              <div className="approach-item clickable"
              onClick={() => navigate("/services", { state: { scrollTo: "licensing-compliance"}})}>
                Licensing & regulatory compliance</div>
              <div className="approach-item clickable"
              onClick={() => navigate("/services", { state: { scrollTo: "supply-chain"}})}>
                Supply chain & vendor management</div>
              <div className="approach-item clickable"
              onClick={() => navigate("/services", { state: { scrollTo: "digital-growth"}})}>
                Digital marketing & brand positioning</div>
              <div className="approach-item clickable"
              onClick={() => navigate("/services", { state: { scrollTo: "technology-pos"}})}>
                Technology & POS integration</div> */}
            {/* </div> */}

            {/* <p>
              Every engagement begins with understanding how your business <span className="highlight">actually operates</span> — 
              and ends with systems that allow it to grow with confidence.
            </p> */}
            {/* <div className="partner-categories"> */}
              {/* <div className="partner-card"> */}
                <p className="clent-type">
                  <strong>This is where systems replace improvisation</strong>
                </p>
              {/* </div> */}
            {/* </div>   */}
          </div>
         </div>
         </section>
        
          






    <section className="testimonial-section" ref={sliderRef}>
  <div className="slider-wrapper">
    
    <div className="slider">
     <div className="slider-track"
      style={{ transform: `translateX(-${index * 320}px)` }}
        >
       {testimonials.map((item, i) => (
        <div className="card" key={i}>
          
          {/* TEXT CARD */}
          {item.text && (
            <>
              <div className="stars">★★★★★</div>
              <p className="quote">{item.text}</p>
              <div className="user">
                <div className="avatar">
                  {item.name ? item.name[0] : "?"}
                </div>
                <div>
                  <h4>{item.name}</h4>
                  <span>{item.role}</span>
                </div>
              </div>
            </>
          )}

          {/* METRIC CARD */}
          {item.highlight && (
            <div className="metric-card">
              <h2>{item.highlight}</h2>
              <h3>{item.title}</h3>
              <p>{item.desc1}</p>
              <p>{item.desc2}</p>
            </div>
          )}

        </div>
      ))}
    </div>
    </div>
  </div>
</section>
      {/* <section className="about-section layer layer-light">
        <div className="about-container">
          <h4>Why FNBDATALAB Exists</h4>
          <h2 className="section-title">Hospitality businesses don't struggle because founders lack effort or intent.</h2>
          <p className="about-subtitle">They struggle when:</p>
          <div className="philosophy-grid">
            <div className="philosophy-item"> */}
            {/* <span className="highlight"><b>Data should simplify decisions, not complicate them</b></span> */}
              {/* <p>Costs rise without margin visibility</p>
            </div>
            <div className="philosophy-item"> */}
              {/* <span className="highlight"> */}
              {/* <b>Systems create freedom, not rigidity</b></span>  */}
              {/* <p>SOPs collapse during peak service</p>
            </div>
            <div className="philosophy-item"> */}
            {/* <span className="highlight"><b>Profitability is a discipline, not luck</b></span>  */}
              {/* <p>Teams rely on individuals instead of systems</p>
            </div>
            <div className="philosophy-item"> */}
            {/* <span className="highlight"><b>Sustainable growth is built, not chased</b></span> */}
              {/* <p>Data exists but doesn't guide decisions</p>
            </div>
            <div className="philosophy-item">  */}
            {/* <span className="highlight"><b>Execution beats ideas</b></span>  */}
              {/* <p>Growth exposes operational cracks</p>
            </div>
            <div className="approach-highlight">
              <p className="about-subhighlight">
                These aren't leadership problems. They're operating system gaps.</p>

                <p>FNBDATALAB exists to close those gaps — with structure that holds under real pressure.
              </p>
             </div> 
          </div>
        </div>
      </section> */}
      <section className="about-section-alt layer layer-light">
        <div className="about-container">
          <h4 className='philosophy-tag'>Why FNBDATALAB Exists</h4>
          <h2 className="section-title"><b>Food & Beverage businesses don't struggle because founders lack effort or intent.</b></h2>
          <p><b>They struggle when:</b></p>
          
          <div className="clients-grid">
            <div className="client-type">
              {/* <span className="highlight"><b>Independent Restaurants</b></span> */}
              <p>Costs rise without margin visibility</p>
            </div>
            <div className="client-type">
              {/* <span className="highlight"><b>Cloud Kitchens</b></span> */}
              <p>SOPs collapse during peak service</p>
            </div>
            <div className="client-type">
              {/* <span className="highlight"><b>Cafés & Bakeries</b></span> */}
            <p>
              Teams rely on individuals instead of systems
            </p>
            </div>
            <div className="client-type">
              {/* <span className="highlight"><b>Bars & Nightlife Concepts</b></span> */}
            <p>
                 Data exists but doesn't guide decisions
            </p>
            </div>
            <div className="client-type">
              {/* <span className="highlight"><b>Hotels & Resorts (F&B Operations)</b></span> */}
            <p>
              Growth exposes operational cracks
            </p>
            </div>
            {/* <div className="client-type"><span className="highlight"><b>Multi-Outlet & Franchise Groups</b></span>
            <p>
              Standardizing operations across locations
            </p>
            </div>
            <div className="client-type"><span className="highlight"><b>International Brands</b></span>
            <p>
              Adapting global systems to local markets
            </p>
            </div> */}
          </div>

          <p className="clients-note">These aren't leadership problems. They're operating system gaps.</p>

          <p className="clients-note">FNBDATALAB exists to close those gaps — with structure that holds under real pressure.</p>
        </div>
        </section>

      <section className="about-section layer layer-light" id="howwework">
        <div className="about-container">
          <h4 className='philosophy-tag'>How We Work</h4>
          <h2 className="section-title">An Operating Partnership — Not Advice</h2>
          
          <p className="ecosystem-intro"><b>
            Every FNBDATALAB engagement follows a disciplined execution model</b>
          </p>

          {/* <p className="ecosystem-intro">
            We lead <span className="highlight">strategy, systems design, and operational outcomes</span>. Execution is delivered through 
            specialist partners across compliance, technology, digital growth, and supply chain — allowing us to maintain 
            <span className="highlight"> accountability without fragmentation</span>.
          </p> */}

          <div className="partner-categories">
            <div className="partner-card">
              <h3>01 — Diagnose Operations</h3>
              <p>
                We map how your business actually runs — not how it appears on paper.
              </p>
            </div>

            <div className="partner-card">
              <h3>02 — Design the System</h3>
              <p>
                Structures built specifically for your scale, format, and constraints.
              </p>
            </div>

            <div className="partner-card">
              <h3>03 — Implement With Your Team</h3>
              <p>
                Workflows embedded into daily execution — not left as documents.
              </p>  
            </div>
            <div className="partner-card">
              <h3>04 — Track & Optimise</h3>
              <p>
                Performance signals refined until execution stabilises and scales
              </p>  
            </div>
          </div>

          <p className="ecosystem-closing">
            <strong>One operating partner. Clear accountability. No hand-offs</strong>
          </p>
        </div>
      </section>
      {/* <section className="about-section layer layer-light">
        <div className="about-container">
          <h4>What Changes When Systems Are in Place</h4>
          <h2 className="section-title">When Structure Replaces Improvisation, Everything Changes</h2> */}
          {/* <p className="about-subtitle">These aren't just values on a wall. These are principles that guide every decision we make and every system we build.</p> */}
          {/* <div className="philosophy-grid">
            <div className="philosophy-item"><span className="highlight"><b>Margins Become Visible</b></span>
              <p>You know where profit is made — and where it leaks.</p>
            </div>
            <div className="philosophy-item"><span className="highlight"><b>Execution Stabilises</b></span>
              <p>Operations hold even during peak hours.</p>
            </div>
            <div className="philosophy-item"><span className="highlight"><b>Decisions Get Clearer</b></span>
              <p>Real operational signals replace guesswork.</p>
            </div>
            <div className="philosophy-item"><span className="highlight"><b>Growth Becomes Predictable</b></span>
              <p>Scale without operational fragility or burnout.</p>
            </div>
            <p className="ecosystem-closing">
            <strong>You move from reacting… to running the business with confidence</strong>
          </p> */}
            {/* <div className="philosophy-item"><span className="highlight"><b>Execution beats ideas</b></span>
              <p>We care less about what sounds good in theory and more about what actually works on your floor, in your kitchen, in your reality. 
                Theory doesn't survive Friday night.</p>
            </div> */}
          {/* </div>
        </div>
      </section> */}

      {/* <section class="systems-section">
  <div class="systems-container">

    <p class="systems-label">What Changes When Systems Are in Place</p>

    <h2 class="systems-title"><b>
      When Structure Replaces Improvisation, Everything Changes</b>
    </h2>

    <div class="systems-points">
      <div class="partner-card">
        <h3>Margins Become Visible</h3>
        <p>You know where profit is made — and where it leaks.</p>
      </div> */}

      {/* <div class="partner-card">
        <h3>Execution Stabilises</h3>
        <p>Operations hold even during peak hours.</p>
      </div>

      <div class="partner-card">
        <h3>Decisions Get Clearer</h3>
        <p>Real operational signals replace guesswork.</p>
      </div>

      <div class="partner-card">
        <h3>Growth Becomes Predictable</h3>
        <p>Scale without operational fragility or burnout.</p>
      </div>
    </div> */}

    {/* <div class="systems-highlight">
      <p>You move from reacting… to running the business with confidence.</p>
    </div>

  </div>
</section> */}



      {/* <section className="about-section-alt layer layer-light">
        <div className="about-container">
          <h2 className="section-title">Who We Work With</h2>
          <p><b>We work across different formats, all facing the same operational challenges:</b></p>
          
          <div className="clients-grid">
            <div className="client-type"><span className="highlight"><b>Independent Restaurants</b></span>
              <p>Building sustainable operations from day one</p>
            </div>
            <div className="client-type"><span className="highlight"><b>Cloud Kitchens</b></span>
              <p>Maximizing efficiency in delivery-first models</p>
            </div>
            <div className="client-type"><span className="highlight"><b>Cafés & Bakeries</b></span>
            <p>
              Scaling production without losing quality
            </p>
            </div>
            <div className="client-type"><span className="highlight"><b>Bars & Nightlife Concepts</b></span>
            <p>
                  Bringing discipline to complex operations
            </p>
            </div>
            <div className="client-type"><span className="highlight"><b>Hotels & Resorts (F&B Operations)</b></span>
            <p>
              Bringing discipline to complex operations
            </p>
            </div>
            <div className="client-type"><span className="highlight"><b>Multi-Outlet & Franchise Groups</b></span>
            <p>
              Standardizing operations across locations
            </p>
            </div>
            <div className="client-type"><span className="highlight"><b>International Brands</b></span>
            <p>
              Adapting global systems to local markets
            </p>
            </div>
          </div>

          <p className="clients-note">Different formats. Same operational challenges.</p>
        </div>
      </section> */}
      {/* <section className="about-section-alt layer layer-light">
        <div className="about-container">
          <h4>Who We Work With</h4>
          <h2 className="section-title">FNBDATALAB works best with hospitality founders and operators who value:</h2> */}
          {/* <p><b>We work across different formats, all facing the same operational challenges:</b></p> */}
          
          {/* <div className="clients-grid">
            <div className="client-type"> */}
              {/* <span className="highlight"><b>Independent Restaurants</b></span> */}
              {/* <p>Systems over shortcuts</p>
            </div>
            <div className="client-type"> */}
              {/* <span className="highlight"><b>Cloud Kitchens</b></span> */}
              {/* <p>Visibility over guesswork</p>
            </div>
            <div className="client-type"> */}
              {/* <span className="highlight"><b>Cafés & Bakeries</b></span> */}
            {/* <p> */}
              {/* Execution discipline
            </p>
            </div>
            <div className="client-type"> */}
              {/* <span className="highlight"><b>Bars & Nightlife Concepts</b></span> */}
            {/* <p>
                  Scalable operations
            </p>
            </div> */}
            {/* <div className="client-type"> */}
              {/* <span className="highlight"><b>Hotels & Resorts (F&B Operations)</b></span> */}
            {/* <p>
              Long-term profitability
            </p> */}
            {/* </div> */}
            {/* <div className="client-type"><span className="highlight"><b>Multi-Outlet & Franchise Groups</b></span>
            <p>
              Standardizing operations across locations
            </p>
            </div>
            <div className="client-type"><span className="highlight"><b>International Brands</b></span>
            <p>
              Adapting global systems to local markets
            </p>
            </div> */}
          {/* // </div> */}

      {/* //     <p className="clients-note">If you want your business to run on structure — we should talk.</p>
      //   </div> */}
      {/* // </section> */}
      {/* <section className="about-section layer layer-light">
  <div className="about-container philosophy-block">

    <h4>Our Operating Philosophy</h4>

    <h2 className="section-title">
      Hospitality success isn't about working harder.
    </h2>

    <p className="philosophy-subtitle">
      It's about building systems that work — consistently.
    </p>

    <div className="philosophy-core">
      <div className="partner-card">
      <h3>Structure creates clarity.</h3>
      <p>Clarity builds confidence. Confidence enables growth.</p></div>
    <div className="philosophy-core">
      <div className="partner-card">
      <h3>Growth stops feeling fragile.</h3>
      <p>When operations are designed properly, scale becomes deliberate.</p>
    </div>
    </div>
    </div>

    <div className="philosophy-highlight-box">
      <p>
        We don't stand outside your business giving opinions.<br />
        We work inside operations — building how your restaurant runs.
      </p>

      <p>That is operating intelligence.</p>
    </div>

  </div>
</section> */}


      {/* <section className="founder-section layer layer-light" id="founder-note">
        <div className="founder-container">
          <h2 className="section-title">A Note from the Founder</h2>
          
          <div className="founder-note">
            <p><span className="highlight"><b>FNBDATALAB was built from experience — not theory.</b></span></p> */}

            {/* <p><b>
              I've watched restaurants with brilliant food close because their numbers didn't add up.
            </b></p>

            <p><b>
              I've seen passionate founders burn out not because they lacked drive.....but because no one ever built them a system.  
            </b></p>
            <p><b>
             After two decades working in kitchens, boardrooms, and operations floors — I built FNBDATALAB for one reason:
              to give F&B founders the operating foundation their businesses deserve.  
            </b></p>

            <p><b>
              We've lived the chaos. The month-ends that don't balance. The margins quietly eroding. 
              The team that only functions when you're in the room.  We built this to change that.
            </b></p> */}

            {/* <p><b>
              We don't chase trends.<br />
              We don't sell shortcuts.<br />
              We build operating systems founders can rely on
            </b></p> */}

            {/* <p><b>
              <strong>
                If you believe that sustainable growth comes from strong foundations, FNBDATALAB was built for you.
              </strong></b>
            </p> */}

            {/* <p className="founder-signature"><span className="highlight"><b>— Founder, FNBDATALAB</b></span></p>
          </div>
        </div>
      </section> */}
      {/* <section className="about-section-alt layer layer-light">
        <div className="about-container">
          <h2 className="section-title">Who We Work With</h2>
          <p><b>We work across different formats, all facing the same operational challenges:</b></p>
          
          <div className="clients-grid">
            <div className="client-type"><span className="highlight"><b>Independent Restaurants</b></span>
              <p>Building sustainable operations from day one</p>
            </div>
            <div className="client-type"><span className="highlight"><b>Cloud Kitchens</b></span>
              <p>Maximizing efficiency in delivery-first models</p>
            </div>
            <div className="client-type"><span className="highlight"><b>Cafés & Bakeries</b></span>
            <p>
              Scaling production without losing quality
            </p>
            </div>
            <div className="client-type"><span className="highlight"><b>Bars & Nightlife Concepts</b></span>
            <p>
                  Bringing discipline to complex operations
            </p>
            </div>
            <div className="client-type"><span className="highlight"><b>Hotels & Resorts (F&B Operations)</b></span>
            <p>
              Bringing discipline to complex operations
            </p>
            </div>
            <div className="client-type"><span className="highlight"><b>Multi-Outlet & Franchise Groups</b></span>
            <p>
              Standardizing operations across locations
            </p>
            </div>
            <div className="client-type"><span className="highlight"><b>International Brands</b></span>
            <p>
              Adapting global systems to local markets
            </p>
            </div>
          </div>

          <p className="clients-note">Different formats. Same operational challenges.</p>
        </div>
      </section> */}

      <section className="cta-section layer layer-light">
        <div className="cta-container">
          <h2>Ready to Build Systems That Last?</h2>
          <p>If clarity, control, and disciplined execution matter to you, the next step is a focused conversation</p>
          {/* <button
            className="nav-cta-btn"
            onClick={() =>navigate("/", { state: { scrollTo: "contact" } })}
    >
            Book a Discovery Call
          </button> */}
          <Link to="/contact" className="btn-2">
              Book a Fit Call
            </Link>
          {/* <a href="/#contact" className="cta-button"> Book a Discovery Call</a> */}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;